<template>
  <v-form
    ref="itemsform"
    lazy-validation
  >
    <v-text-field
      v-model="editedItem.f5_nic_name"
      label="F5 NIC Name"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.private_ip_address"
      label="Private IP"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.public_ip_address"
      label="Public IP"
      outlined
      :rules="[rules.required]"
    />
    <v-switch
      v-model="editedItem.rds_server"
      label="RDS Server"
      true-value="y"
      false-value="n"
    />
    <v-select
      v-model="editedItem.region_id"
      :items="regions"
      item-text="region_short"
      item-value="region_id"
      label="Region"
    />
  </v-form>
</template>
<script>
  export default {
    name: 'F5nicForm',
    props: {
      editedItem: Object,
      regions: Array
    },
    data () {
      return {
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
  }
</script>